const defaultState = {
  activeQuizzes: null,
  myTurnQuizzes: null,
  games: null,
  bots: null,
  history: null,
}

export default defaultState
